import React, { useEffect } from "react";

const Game = () => {
  function theGame() {
    const canvas = document.getElementById("canvas");
    // getContext permet de retourner un contexte de dessin sur le canvas
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.src = "./assets/img/flappy-bird-set.png";

    // Réglages généraux
    let gamePlaying = false;
    const gravity = 0.5;
    const speed = 6.2;
    const size = [51, 36];
    const jump = -6.9;
    const cTenth = canvas.width / 10;

    // Réglage des poteaux
    const pipeWidth = 78;
    const pipeGap = 270;
    const pipeLoc = () =>
      Math.random() * (canvas.height - (pipeGap + pipeWidth) - pipeWidth) +
      pipeWidth;

    let index = 0,
      bestScore = 0,
      currentScore = 0,
      pipes = [],
      flight,
      flyHeight;

    const setup = () => {
      currentScore = 0;
      flight = jump;
      flyHeight = canvas.height / 2 - size[1] / 2;
      // Pour le pipes avec array vide (voir ligne 29), je crée ici un array de 3 éléments (poteaux) contenant un tableau de 2 éléments
      pipes = Array(3)
        .fill()
        .map((a, i) => [canvas.width + i * (pipeGap + pipeWidth), pipeLoc()]);
    };

    const render = () => {
      index++;

      // Découpe de l'image avec drawImage (image, sx, sy, sLargeur, sHauteur)
      // Les 4 paramètres "s" pour la source, les 4 derniers pour la destination

      // Le décors de fond doit défiler 2 fois moins vite que les poteaux et doit se déplacer en arrière, d'où le "-".
      ctx.drawImage(
        img,
        0,
        0,
        canvas.width,
        canvas.height,
        -((index * (speed / 2)) % canvas.width) + canvas.width,
        0,
        canvas.width,
        canvas.height
      );
      // Il faut enlever le + canva.width pour que les 2 images se suivent
      ctx.drawImage(
        img,
        0,
        0,
        canvas.width,
        canvas.height,
        -((index * (speed / 2)) % canvas.width),
        0,
        canvas.width,
        canvas.height
      );

      // Condition pour gamePlaying = true (voir plus bas)
      // On le positionne a "cTenth", soit 1/10ème de l'écran
      if (gamePlaying) {
        ctx.drawImage(
          img,
          432,
          Math.floor((index % 9) / 3) * size[1],
          ...size,
          cTenth,
          flyHeight,
          ...size
        );

        flight += gravity;
        // Je soumets l'oiseau à la gravité en demande le plus petit nombre de chaque variable
        flyHeight = Math.min(flyHeight + flight, canvas.height - size[1]);
      } else {
        ctx.drawImage(
          img,
          432,
          Math.floor((index % 9) / 3) * size[1],
          ...size,
          canvas.width / 2 - size[0] / 2,
          flyHeight,
          ...size
        );
        flyHeight = canvas.height / 2 - size[1] / 2;

        // Pour écrire sur le canvas (axe des x : 55 ; axe des y : 245)
        ctx.fillStyle = "white";
        ctx.fillText(`Meilleur score : ${bestScore}`, 55, 245);
        ctx.fillText("cliquez pour jouer", 48, 535);
        // Possibilité de mise en forme rudimentaire sur le canvas, avec police très générique
        ctx.font = "bold 30px courier";
      }

      // Affichage des poteaux
      // forEach à la place de map pour résoudre l'erreur "Line 111:26:  Array.prototype.map() expects a return value from arrow function"
      if (gamePlaying) {
        pipes.forEach((pipe) => {
          pipe[0] -= speed;

          // Poteaux du haut
          ctx.drawImage(
            img,
            432,
            588 - pipe[1],
            pipeWidth,
            pipe[1],
            pipe[0],
            0,
            pipeWidth,
            pipe[1]
          );

          // Poteaux du bas
          ctx.drawImage(
            img,
            432 + pipeWidth,
            108,
            pipeWidth,
            canvas.height - pipe[1] + pipeGap,
            pipe[0],
            pipe[1] + pipeGap,
            pipeWidth,
            canvas.height - pipe[1] + pipeGap
          );

          if (pipe[0] <= -pipeWidth) {
            currentScore++;
            bestScore = Math.max(bestScore, currentScore);

            // Retrait d'un poteau et création d'un nouveau
            pipes = [
              ...pipes.slice(1),
              [pipes[pipes.length - 1][0] + pipeGap + pipeWidth, pipeLoc()],
            ];
          }
          // Fin de la partie si l'oiseau touche le poteau
          // La méthode every permet de tester de nombreuses conditions (pour voir si elles sont toutes vraies sans mettre des "et" partout
          // Pour dire "ou alors" : "||"
          if (
            [
              pipe[0] <= cTenth + size[0],
              pipe[0] + pipeWidth >= cTenth,
              pipe[1] > flyHeight || pipe[1] + pipeGap < flyHeight + size[1],
            ].every((elem) => elem)
          ) {
            gamePlaying = false;
            setup();
          }
        });
      }

      document.getElementById(
        "bestScore"
      ).innerHTML = `Meilleur : ${bestScore}`;
      document.getElementById(
        "currentScore"
      ).innerHTML = `Actuel : ${currentScore}`;
      // 500 permet de ralentir mon animation (1000ms / 2), env 300 pour 1000/3
      window.requestAnimationFrame(render, 500);
    };

    // Je mets un setup pour relancer le jeu
    setup();
    img.onload = render;

    // Pour que le jeu se lance au clic
    document.addEventListener("click", () => (gamePlaying = true));
    window.onclick = () => (flight = jump);
  }
  useEffect(() => {
    theGame();
  });
  return (
    <div>
      <div className="page-container-game">
        <div className="game-container">
          <h1>Flappy bat</h1>
          <div className="score-container">
            <div id="bestScore"></div>
            <div id="currentScore"></div>
            {/* <div className="click-to-play"></div> */}
          </div>
          <canvas id="canvas" width="431" height="768"></canvas>
        </div>
      </div>
    </div>
  );
};

export default Game;
